// Copyright (c) 2016 Deere & Company

import {isNotEmpty, isNotNull} from '../../../shared/services/claim-shared-helper';
import MassChannelPdiClaim from '@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-pdi';
import {removeEmptyRows} from '../../../shared/services/empty-claim-rows';

const hasAtLeastOneClaimItem = claim => claim.parts.length || claim.labor.length || claim.otherCredits.length;

const hasComplaintCauseCorrection = complaintCauseCorrection => [
    isNotEmpty(complaintCauseCorrection.causeOfComplaining),
    isNotEmpty(complaintCauseCorrection.howWasComplaintCorrected),
    isNotEmpty(complaintCauseCorrection.operatorsComplaint)
].every(rule => rule);

const isComplaintCauseCorrectionValid = (installedBy, complaintCauseCorrection) => installedBy === 'R' ?
    isNotEmpty(complaintCauseCorrection.causeOfComplaining) :
    hasComplaintCauseCorrection(complaintCauseCorrection);

export const isAfterStartDate = (endDate, startDate) => startDate <= endDate;

export const canShowAllSections = (claimNumber, isValidClaim) => isValidClaim || isNotEmpty(claimNumber);

export const isValidClaim = claim => [
    isNotEmpty(claim.failureInfo.failurePartNumber),
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.referenceInfo.ownershipStatus.key),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isNotEmpty(claim.itemNumber),
    isNotEmpty(claim.previousInvoiceNumber),
    claim.retailInstallDate !== null,
    isAfterStartDate(claim.failureInfo.repairDate, claim.failureInfo.failureDate)
].every(rule => rule);

export const saveValidate = claim => [
    isValidClaim(claim),
    isNotEmpty(claim.additionalFailureInfo.failureMode.key),
    isNotEmpty(claim.additionalFailureInfo.failureArea),
    isNotEmpty(claim.additionalFailureInfo.downtime.key),
    isComplaintCauseCorrectionValid(claim.installedBy.key, claim.complaintCauseCommentsBasis),
    hasAtLeastOneClaimItem(removeEmptyRows(claim, MassChannelPdiClaim))
].every(rule => rule);

export const mapFormValidation = (property, value) => {

    const map = {
        approvalDate: isNotNull,
        purchaseOrder: isNotEmpty,
        responsibleAccount: isNotEmpty,
        retailerName: isNotEmpty,
        setupDate: isNotNull,
        storeNumber: isNotEmpty,
        workOrderOne: isNotEmpty,
        workOrderThree: isNotEmpty
    };

    return map[property](value);

};

export const removeEmptyPins = claim => ({
    ...claim,
    pins: claim.pins.filter(pin => isNotEmpty(pin))
});

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) => selectedAction === 'VALIDATE' ?
!validationFailed && !currentPageValidity :
    false;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/services/claim-validation-helper.js